var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.type === 'Announcement')?_c('p',{staticClass:"p-base-bold text-secondary-500"},[_vm._v(" "+_vm._s(_vm.$t("labels.announcement"))+" ")]):_c('p',{staticClass:"p-base-bold text-secondary-500"},[_vm._v(" "+_vm._s(_vm.$t("labels.system"))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }